<template>
  <div v-if="!loading">
    <page-header></page-header>

    <div class="container _margin-bottom-30">
      <div class="row">
        <div class="col-md-12">
          <page-steps :steps="pageSteps"></page-steps>
        </div>
      </div>

      <div class="row _margin-top-20 _margin-bottom-20">
        <div class="col-xs-12 col-sm-6">
          <uiv-btn type="secondary" @click="onToggleFilter()">
            Filter Results
          </uiv-btn>
        </div>

        <div class="col-xs-12 col-sm-6" v-if="carbonOffset">
          <carbon-foot-print :data="carbonOffsetEquivalent" class="pull-right" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
                    <div class="alert alert-info" v-if="showVatDisclaimer">
            Following the UK Government decision, electricity prices and estimates in this comparison include 0% VAT for qualifying
            domestic electricity supplies in Great Britain from 1 October 2026 to 31 March 2027. Gas prices continue to include 5% VAT.
          </div>

          <div class="alert alert-info _margin-top-20" v-if="!loading && results.length == 0">
            No results found {{ unfilteredResults.length == 0 ? '' : 'for you chosen filters' }}
          </div>

          <result-item v-for="result in results" :data="result" :key="`${result.tariffId}${result.payMethod}`"
            @onMore="onMore(result)" @onChoose="onProceed(result)"
            @onVehicleSummary="onVehicleSummary(result)"></result-item>
        </div>
      </div>
    </div>

    <collaspable-sidebar ref="sidebar"></collaspable-sidebar>
  </div>
</template>

<script>
import CarbonFootPrint from '@/components/carbon-offset/CarbonFootPrint';
import ResultItem from '@/components/quote-results/ResultItem';
import CollaspableSidebar from '@/components/quote-results/CollaspableSidebar';
import PageHeader from '@/components/page-header/PageHeader';
import PageSteps from '@/components/page-steps/PageSteps';

import { mapGetters, mapState } from 'vuex';

export default {
  name: 'QuoteResults',
  data() {
    return {
      showVatDisclaimer: false,
      pageSteps: [
        { name: 'Your Current Energy Information' },
        { name: 'Choose Your New Deal', active: true },
        { name: 'Sign Up' },
        { name: 'Switch Complete' }
      ]
    };
  },
    async created() {
    try {
      const response = await fetch('/feature-flags.json?_=' + Date.now());
      if (response.ok) {
        const flags = await response.json();
        this.showVatDisclaimer = flags.showVatDisclaimer === true;
      }
    } catch (e) {
      this.showVatDisclaimer = false;
    }
  },

  async mounted() {
    const preventRefresh = ['tariffDetails', 'personalDetails'];

    if (preventRefresh.indexOf(this.prevRoute.name) < 0 || this.results.length == 0) {
      await this.$store.dispatch('quote_results/getQuoteResults');

      if (this.unfilteredResults.length > 0) {
        await this.$store.dispatch('quote_results/getCurrentTariff', this.unfilteredResults[0].tariffId);
      }

      if (this.carbonOffset) {
        await this.$store.dispatch('carbon_offset/getCarbonEquivalent');
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    })
  },
  computed: {
    ...mapGetters({
      results: 'quote_results/results'
    }),
    ...mapState({
      carbonOffset: ({ app_settings, storage }) => {
        return app_settings.carbonOffset && storage.quote.switchType != 'electricityToElectricity';
      },
      carbonOffsetEquivalent: ({ carbon_offset }) => carbon_offset.equivalent,
      loading: ({ page_loader }) => page_loader.show,
      unfilteredResults: ({ quote_results }) => quote_results.results,
      currentTariff: ({ quote_results }) => quote_results.currentTariff
    })
  },
  methods: {
    async onMore({ tariffId, tariffName, supplierName, payMethod, switchOption }) {
      await this.$store.dispatch('storage/save', {
        prop: 'quote',
        value: { proposedPayMethod: payMethod, switchOption }
      });

      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
      this.$store.dispatch('tracing/addAction', { name: 'Tariff Id', value: tariffId });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Tariff Details' });
      await this.$store.dispatch('tracing/saveActions');

      this.$router.push({
        name: 'tariffDetails',
        params: { tariffId }
      });
    },
    async onProceed({ tariffId, payMethod, supplierId }) {
      await this.$store.dispatch('storage/save', {
        prop: 'quote',
        value: { proposedPayMethod: payMethod }
      });
      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
      this.$store.dispatch('tracing/addAction', { name: 'Tariff Id', value: tariffId });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Switch Now' });
      await this.$store.dispatch('tracing/saveActions');
      await this.$store.dispatch('quote_results/switchNow', { tariffId, supplierId });
    },
    onToggleFilter() {
      this.$refs.sidebar.toggleOpen();
    }
  },
  components: {
    CarbonFootPrint,
    ResultItem,
    CollaspableSidebar,
    PageHeader,
    PageSteps
  }
};
</script>

<style lang="scss" scoped>
.button-top {
  position: fixed;
  top: 20px;
  right: 20px;
}
</style>
